import * as angular from "angular";
import {IController} from "angular";

export class DeliveriesTotalsIndicationCtrl implements IController {

    services: any;

    public totalSpots: number;
    public totalPackages: number;
    public totalWeight: number;
    public totalVolume: number;
    public dimensionsConfig: string;
    public weightConfig: string;

    constructor(private splitService) {
        this.weightConfig = this.splitService.getWeightUnit();
        this.dimensionsConfig = this.splitService.getVolumeUnit();

    }

    $onInit() {
        this._calcServiceTotals();
    }

    $onChanges(changes: angular.IOnChangesObject) {
        if (changes.services) {
            this._calcServiceTotals();
        }
    }

    private _calcServiceTotals() {

        this.totalSpots = 0;
        this.totalPackages = 0;
        this.totalWeight = 0;
        this.totalVolume = 0;

        this.services.forEach(service => {
            (service.packageList || []).forEach(p => {

                this.totalPackages += p.items.reduce((sum, i) => {
                    return sum + (i.count || 0);
                }, 0);

                this.totalSpots += p.items.reduce((sum, i) => {
                    return sum + (i.requiredSpots || 0);
                }, 0);

                this.totalWeight += p.items.reduce((sum, i) => {
                    return sum + (i.weight || 0);
                }, 0);

                this.totalVolume += p.items.reduce((sum, i) => {
                    return sum + (i.volume || i.dimensions?.cube || 0);
                }, 0);

            })
        })
    }
}

angular
    .module('bringoz.admin.deliveries')
    .component('deliveriesTotalsIndication', {
        bindings: {
            services: '<?',
        },
        template: require('./deliveries-totals-indication.html').default,
        controller: DeliveriesTotalsIndicationCtrl
    });
